import { render, staticRenderFns } from "./HeritageDetailThai.vue?vue&type=template&id=1df26028&"
import script from "./HeritageDetailThai.vue?vue&type=script&lang=js&"
export * from "./HeritageDetailThai.vue?vue&type=script&lang=js&"
import style0 from "./HeritageDetailThai.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports